__turbopack_context__.v({
  "body": "dialog-module-scss-module__f1bJPG__body",
  "close": "dialog-module-scss-module__f1bJPG__close",
  "content": "dialog-module-scss-module__f1bJPG__content",
  "description": "dialog-module-scss-module__f1bJPG__description",
  "header": "dialog-module-scss-module__f1bJPG__header",
  "no_background": "dialog-module-scss-module__f1bJPG__no_background",
  "overlay": "dialog-module-scss-module__f1bJPG__overlay",
  "scroll": "dialog-module-scss-module__f1bJPG__scroll",
  "sr_only": "dialog-module-scss-module__f1bJPG__sr_only",
  "title": "dialog-module-scss-module__f1bJPG__title",
});
